/* NOTE: Resolving 'eslint-disable prefer-arrow-functions'
// will require architecture and refactoring of the entire WW engine
*/
// tslint:disable: max-line-length

import { CoreCustomPageType } from '@workflow/class/workflow.type';
import { CustomPageBase } from '@workflow/dynamic-render/page/shared/core-custom-page.decorator';

// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
export type OAOCustomPageType = CoreCustomPageType | 'oao-eligibility';

// eslint-disable-next-line prefer-arrow-functions/prefer-arrow-functions
export function OAOCustomPage(controlType: OAOCustomPageType): (target) => void {
  return (target) => CustomPageBase<OAOCustomPageType>(controlType, target);
}
